import { getDoctorById } from "../services/doctorService";
import { getAssignmentByAdmissionId } from "../services/PatientAssignmentService";

const toPositiveId = (value) => {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.trunc(n);
};

/**
 * Resolve prescription_id for pathology / medicine invoices.
 * Accepts camelCase, snake_case, nested prescription objects, and common aliases.
 */
export const resolveInvoicePrescriptionId = (...candidates) => {
  for (const raw of candidates) {
    if (raw == null || raw === "") continue;
    if (typeof raw === "object" && !Array.isArray(raw)) {
      const nested = resolveInvoicePrescriptionId(
        raw.prescriptionId,
        raw.prescription_id,
        raw.opdPrescriptionId,
        raw.opd_prescription_id,
        raw.ipdPrescriptionId,
        raw.ipd_prescription_id,
        raw.id
      );
      if (nested != null) return nested;
      continue;
    }
    const id = toPositiveId(raw);
    if (id != null) return id;
  }
  return undefined;
};

/**
 * Resolve department_id for medicine-issue invoices.
 * Prefers an explicit id, then doctor profile, then IPD admission assignment.
 */
export const resolveInvoiceDepartmentId = async ({
  departmentId = null,
  department_id = null,
  doctorId = null,
  doctor_id = null,
  admissionId = null,
  admission_id = null,
} = {}) => {
  const direct =
    toPositiveId(departmentId) ?? toPositiveId(department_id);
  if (direct != null) return direct;

  const resolvedDoctorId =
    toPositiveId(doctorId) ?? toPositiveId(doctor_id);
  if (resolvedDoctorId != null) {
    try {
      const doctor = await getDoctorById(resolvedDoctorId);
      const fromDoctor =
        toPositiveId(doctor?.departmentId) ??
        toPositiveId(doctor?.department_id);
      if (fromDoctor != null) return fromDoctor;
    } catch {
      // Non-blocking — invoice can still be created without department_id
    }
  }

  const resolvedAdmissionId =
    toPositiveId(admissionId) ?? toPositiveId(admission_id);
  if (resolvedAdmissionId != null) {
    try {
      const assignments = await getAssignmentByAdmissionId(resolvedAdmissionId);
      const assignment = Array.isArray(assignments)
        ? assignments[0]
        : assignments;
      const fromAssignment =
        toPositiveId(assignment?.departmentId) ??
        toPositiveId(assignment?.department_id);
      if (fromAssignment != null) return fromAssignment;
    } catch {
      // Non-blocking
    }
  }

  return undefined;
};
